module.exports = function getResource(label, vars = []) {
    let resources = {
        done: 'Terminé',
        clear: 'Incolore'
    };
    return resources[label];
};
